import React from 'react';
import { createBrowserRouter, redirect, RouterProvider } from 'react-router-dom';

import './App.css';
import RootLayout from './pages/Root';
import HomePage from './pages/Home';
import RegisterPage from './pages/Register';
import WalletPage from './pages/Wallet';
import ProfilePage from './pages/Profile';
import LoginPage from './pages/Login';
import AcoesList from './pages/public/AcoesList';
import FIIsList from './pages/public/FIIsList';
import StocksList from './pages/public/StocksList';
import ETFsList from './pages/public/ETFsList';
import REITsList from './pages/public/REITsList';

function App() {

  const isTokenValid = () => {
    const token = localStorage.getItem("token");
    if (!token) return false;

    try {
      const payload = JSON.parse(atob(token.split(".")[1]));
      return payload.exp > Date.now() / 1000;
    } catch {
      return false;
    }
  }

  // 🔐 Salva apenas o token
  const loginHandler = (data) => {
    try {
      console.warn(data);
      // localStorage.setItem('token', data.token);
      Object.keys(data).forEach((key) => {
        localStorage.setItem(key, data[key]);
      });      
      window.location.href = "/carteira";
    } catch (error) {
      console.log(error);
    }
  };

  const logoutHandler = () => {
    localStorage.removeItem('token');
    localStorage.clear();
    window.location.href = "/login";
  };

  // 🔎 Verifica token e expiração
  const checkAuthLoader = () => {
    const token = localStorage.getItem("token");

    if (!token) {
      return redirect('/login');
    }

    try {
      const payload = JSON.parse(atob(token.split('.')[1]));

      const now = Date.now() / 1000;

      if (payload.exp < now) {
        localStorage.removeItem("token");
        return redirect('/login');
      }

      return null;

    } catch (error) {
      localStorage.removeItem("token");
      return redirect('/login');
    }
  };

  const router = createBrowserRouter([
    {
      path: '/',
      element: <RootLayout isLoggedIn={isTokenValid()} onLogout={logoutHandler} />,
      children: [
        { path: '/', element: <HomePage /> },
        { path: '/acoes', element: <AcoesList /> },
        { path: '/fiis', element: <FIIsList /> },
        { path: '/stocks', element: <StocksList /> },
        { path: '/etfs', element: <ETFsList /> },
        { path: '/reits', element: <REITsList /> },
        { path: '/cadastro', element: <RegisterPage /> },
        { path: '/carteira', element: <WalletPage />, loader: checkAuthLoader },
        { path: '/perfil', element: <ProfilePage />, loader: checkAuthLoader },
        { path: '/login', element: <LoginPage onLogin={loginHandler} /> }
      ]
    },
  ]);

  return <RouterProvider router={router} />;
}

export default App;